import { Box } from 'lucide-react'

export default function AppsIcon() {
  return <Box size={24} strokeWidth={2} />
}
